import React, { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import axios from '../../../utils/axiosConfig';
import { Col, Row } from 'reactstrap';
import ModalBaseSm from '../../modals/modal-base-sm';
import FormModalCreateVehiculo from '../forms/formModalCreateVehiculo';

const ModalVehiculos = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [id, setId] = useState(-1);
    const [placa, setPlaca] = useState('');
    const [placaBusqueda, setPlacaBusqueda] = useState('');
    const [marca, setMarca] = useState('');
    const [color, setColor] = useState('');
    const [linea, setLinea] = useState('');
    const [modelo, setModelo] = useState('');
    const [operadorGpsId, setOperadorGpsId] = useState(null);
    const [propietarioId, setPropietarioId] = useState(null);

    const [vehicles, setVehicles] = useState([]);

    const [operadoresGps, setOperadoresGps] = useState([]);
    const [propietarios, setPropietarios] = useState([]);

    const [dialogOpen, setDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return vehicles;
        return vehicles.filter(item => {
            return Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            );
        });
    }, [vehicles, debouncedTerm]);

    const getOperadoresGps = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_SERVER + '/maestros/getoperadorgps'
            );
            setOperadoresGps(response.data.data || []);
        } catch (error) {
            console.log('Error al obtener operadores GPS:', error);
        }
    };

    const getPropietarios = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_SERVER + '/maestros/getpropietarios'
            );
            setPropietarios(response.data.data || []);
        } catch (error) {
            console.log('Error al obtener propietarios:', error);
        }
    };

    const validatePlacaUnique = async (placa) => {
        console.log('Validando placa única:', placa);
        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER}/maestros/existevehiculos`,
                { Placa: placa },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );
            console.log('Respuesta de validación de placa:', data);
            // si el backend marca error
            if (!data?.success) {
                Swal.fire("Error", data?.message || "No se pudo validar la placa.", "error");
                return false;
            }

            if (data?.success && data?.data?.length > 0) {
                Swal.fire("Error", "La placa ya existe. Por favor, ingrese una placa única.", "error");
                return false;
            }

            return true;
        } catch (error) {
            console.log("Error al validar placa única:", error);
            Swal.fire("Error", "No se pudo validar la placa.", "error");
            return false;
        }
    };


    const listarVehiculos = async () => {
        await axios
            .post(
                process.env.REACT_APP_SERVER + '/maestros/getvehiculos',
                {
                    Placa: placaBusqueda || '',
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'tkn'
                        )}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    console.log('Vehículos cargados:', res.data.data);
                    setVehicles(res.data.data);
                } else Swal.fire('Error', 'No se pudo cargar vehículos', 'error');
            })
            .catch(() =>
                Swal.fire('Error', 'Falla de red al cargar lista', 'error')
            );
    };

    const toggleDialog = () => {
        setDialogOpen(o => !o);
        if (dialogOpen) {
            setMarca('');
            setColor('');
            setLinea('');
            setModelo('');
            setOperadorGpsId(null);
            setPropietarioId(null);
            setPlaca('');
            setId(-1);
        }
    };

    const editarVehicles = item => {
        console.log('Editando vehicles:', item);
        setId(item.idLokVehiculo || -1);
        setPlaca(item.Placa || '');
        setMarca(item.Marca || '');
        setColor(item.Color || '');
        setLinea(item.Linea || '');
        setModelo(item.Modelo || '');
        setOperadorGpsId(item.FkOperadorGPS || null);
        setPropietarioId(item.FkPropietario || null);
        setDialogOpen(true);
    };

    const limpiarCampos = () => {
        setId(-1);
        setPlaca('');
        setMarca('');
        setColor('');
        setLinea('');
        setModelo('');
        setOperadorGpsId(null);
        setPropietarioId(null);
    };

    const guardar = ({
        placa,
        marca,
        color,
        linea,
        modelo,
        operadorGpsId,
        propietarioId,
    }) => {
        if (
            !placa.trim() ||
            !marca.trim() ||
            !color.trim() ||
            !linea.trim() ||
            !modelo.trim() ||
            !operadorGpsId ||
            !propietarioId
        ) {
            Swal.fire(
                'Error',
                'Debe completar todos los campos: Placa, Marca, Color, Línea, Modelo, Operador GPS y Propietario',
                'error'
            );
            return;
        }
        const payloadCreate = {
            id: -1,
            Placa: placa,
            Marca: marca,
            Color: color,
            Linea: linea,
            Modelo: modelo,
            FkOperadorGPS: operadorGpsId,
            FkPropietario: propietarioId,
        };
        console.log('Payload a subir para crear:', payloadCreate);
        validatePlacaUnique(payloadCreate.Placa);
        axios
            .post(
                process.env.REACT_APP_SERVER + '/maestros/setvehiculo',
                JSON.stringify(payloadCreate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'tkn'
                        )}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                    return;
                }
                console.log('Vehículo guardado:', res.data);
                Swal.fire('Éxito', 'Vehículo guardado', 'success');
                listarVehiculos();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire('Error', 'No se pudo guardar', 'error')
            );
    };

    const update = ({
        placa,
        marca,
        color,
        linea,
        modelo,
        operadorGpsId,
        propietarioId,
    }) => {
        console.log('Actualizando vehículo con ID:', id);
        console.log('Datos a actualizar:', {
            placa,
            marca,
            color,
            linea,
            modelo,
            operadorGpsId,
            propietarioId,
        });
        if (
            !placa.trim() ||
            !marca.trim() ||
            !color.trim() ||
            !linea.trim() ||
            !modelo.trim() ||
            !operadorGpsId ||
            !propietarioId
        ) {
            Swal.fire(
                'Error',
                'Debe completar todos los campos: Placa, Marca, Color, Línea, Modelo, Operador GPS y Propietario',
                'error'
            );
            return;
        }
        const payloadUpdate = {
            id: id,
            Placa: placa,
            Marca: marca,
            Color: color,
            Linea: linea,
            Modelo: modelo,
            FkOperadorGPS: operadorGpsId,
            FkPropietario: propietarioId,
        };
        console.log('Payload a subir para actualizar:', payloadUpdate);
        validatePlacaUnique(payloadUpdate.Placa);
        axios
            .post(
                process.env.REACT_APP_SERVER + '/maestros/setvehiculo',
                JSON.stringify(payloadUpdate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'tkn'
                        )}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo actualizar', 'error');
                    return;
                }
                console.log('Vehículo actualizado:', res.data);
                Swal.fire('Éxito', 'Vehículo actualizado', 'success');
                listarVehiculos();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire('Error', 'No se pudo actualizar', 'error')
            );
    };

    const handleSaveOrUpdate = ({
        placa,
        marca,
        color,
        linea,
        modelo,
        operadorGpsId,
        propietarioId,
    }) => {
        if (id === -1) {
            guardar({
                placa,
                marca,
                color,
                linea,
                modelo,
                operadorGpsId,
                propietarioId,
            });
        } else {
            update({
                placa,
                marca,
                color,
                linea,
                modelo,
                operadorGpsId,
                propietarioId,
            });
        }
    };

    useEffect(() => {
        const handler = setTimeout(
            () =>
                setDebouncedTerm(
                    searchTerm.trim().toLowerCase()
                ),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        listarVehiculos();
    }, [placaBusqueda]);

    return (
        <>
            {/* Estilos específicos del componente */}
            <style>
                {`
                @media (max-width: 575.98px) {
                    .btn-nuevo-vehiculo {
                        width: 100%;
                    }
                }
            `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar placa..."
                        value={placaBusqueda}
                        onChange={e => setPlacaBusqueda(e.target.value)}
                        style={{
                            height: '38px',
                            boxSizing: 'border-box',
                        }}
                    />
                </Col>
                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nuevo-vehiculo"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nuevo Vehículo
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '17%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Placa
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '17%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Color
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '17%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Marca
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '17%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Modelo
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '17%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Línea
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '15%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered?.map((item, i) => (
                                <tr key={i}>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Placa || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Color || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Marca || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Modelo || '-'}
                                    </td>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {item.Linea || '-'}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits)
                                                    editarVehicles(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{
                                                    color: '#006699',
                                                }}
                                            />
                                        </a>{' '}
                                        {/* 
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                // borrarInstalador(item);
                                            }}
                                        >
                                            <i
                                                className="bx bx-trash"
                                                style={{
                                                    color: '#006699',
                                                }}
                                            />
                                        </a> 
                                        */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <ModalBaseSm
                isOpen={dialogOpen}
                title={id === -1 ? 'Crear vehiculo' : 'Editar vehiculo'}
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateVehiculo
                        onSave={handleSaveOrUpdate}
                        initialData={{
                            Placa: placa,
                            Marca: marca,
                            Color: color,
                            Linea: linea,
                            Modelo: modelo,
                            OperadorGpsId: operadorGpsId,
                            PropietarioId: propietarioId,
                        }}
                    />
                }
            />
        </>
    );
};

export default ModalVehiculos;
